import Carousel from './Carousel';
import styles from './CarouselFeatured.module.scss';

export default function CarouselAuthors({ data }) {
    return <Carousel data={data} moduleStyles={styles} />;
}
